import { render } from "./AppPaletteTemplatesModal.vue?vue&type=template&id=26bb2e45&scoped=true&ts=true"
import script from "./AppPaletteTemplatesModal.vue?vue&type=script&lang=ts"
export * from "./AppPaletteTemplatesModal.vue?vue&type=script&lang=ts"

import "./AppPaletteTemplatesModal.vue?vue&type=style&index=0&id=26bb2e45&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26bb2e45"]])

export default __exports__